import axios from "axios";
import { responseError } from "../../uteis/ResponseApi";

const baseAxiosPublic = axios.create({
    baseURL: process.env.REACT_APP_API_DEMOSTENES
});

baseAxiosPublic.interceptors.response.use(
    (response) => response
);

baseAxiosPublic.interceptors.response.use(
    (response) => response,
    (error) => responseError(error)
);

export default baseAxiosPublic;